'use client';

import * as React from 'react';

type HeroTabContextType = {
  activeTab: string;
  setActiveTab: (tab: string) => void;
};

const HeroTabContext = React.createContext<HeroTabContextType | undefined>(
  undefined
);

export function HeroTabProvider({
  children
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  const [activeTab, setActiveTab] = React.useState('feature1');

  return (
    <HeroTabContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </HeroTabContext.Provider>
  );
}

export function useHeroTab(): HeroTabContextType {
  const context = React.useContext(HeroTabContext);
  if (context === undefined) {
    throw new Error('useHeroTab must be used within a HeroTabProvider');
  }
  return context;
}

// Map from product names to tab values
export const PRODUCT_TO_TAB_MAP: Record<string, string> = {
  website: 'feature1',
  budget: 'feature2',
  events: 'feature3',
  timeline: 'feature4'
};

